import i18n from "@/i18n";
import { Notification } from "element-ui";
function responseHandle(response) {
  let res = response.data;
  // console.log(res);
  // Message.closeAll();// 关闭所有message
  let messageCon = "";
  //维护一个需要单独处理或者不处理的状态码集合
  let nohandledCodes = [
    "1001",
    "1007",
    "A0201",
    "A0210",
    "5050",
    "C0102",
    "A0442",
  ];

  // 获取blob文件 成功的 不处理提示
  let getBlobUrl = [
    {
      method: "GET",
      uri: "^/v2/notice/.*/attaches$",
    },
  ];
  if (
    getBlobUrl.some((item) => {
      if (response.config.method.toUpperCase() == item.method) {
        let regex = new RegExp(item.uri);
        if (regex.test(response.config.url)) {
          return true;
        }
      }
      return false;
    })
  ) {
    return;
  }
  //返回码非以上数组中数据，统一处理，否则单独处理
  if (!nohandledCodes.includes(res.resultCode)) {
    // messageCon = res.message;
    messageCon = i18n.t("httpResponsePromptMessage." + res.resultCode);
    Notification.error({
      showClose: true,
      message: messageCon,
    });
  }

  /**单独处理逻辑 */
  if ((res.resultCode == "A0201") | (res.resultCode == "A0210")) {
    messageCon = i18n.t(`httpResponsePromptMessage.1008`);
    Notification.error({
      showClose: true,
      message: messageCon,
    });
  } else if (res.resultCode == "C0109") {
    //当前refreshToken 过期， 通知主应用退出
    // actions.setGlobalState({
    //   getTokenError: true,
    // });
  }
}
export default responseHandle;
